import React, { useState } from 'react';
import {
  BaseModal,
  Button,
  Input,
  Multiselect,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import useTeamListContext from 'contexts/team-list.context';
import { TeamType } from 'models/team-list.model';
import { KITCHEN_STAFF_ROLES } from 'utils/enum';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

const EditMember = ({ onClose }: { onClose: (success?: boolean) => void }) => {
  const { editMemberFormData, setEditMemberFormData, departments } = useTeamListContext();

  const [loading, setLoading] = useState(false);

  const handleChange = (value: string, fieldType: keyof TeamType) => {
    setEditMemberFormData({
      ...editMemberFormData,
      [fieldType]: value
    });
  };

  const editMember = async () => {
    setLoading(true);
    const data = {
      first_name: editMemberFormData.first_name,
      last_name: editMemberFormData.last_name,
      phone_number: editMemberFormData.phone_number,
      email: editMemberFormData.email,
      department_id: editMemberFormData.department_id,
      role: editMemberFormData.role
    };

    try {
      const res = await apiService.put(`kitchen/staff/${editMemberFormData.id}`, {
        data,
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      if (res.status === 200) {
        onClose(true);
        toast(<ToastMessage type='success' message={res.data.message} />);
      }
    } catch (error: any) {
      onClose();
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const isFormDataInValid = (formData: TeamType): boolean => {
    return (
      !formData.department_id ||
      !formData.first_name ||
      !formData.last_name ||
      !formData.role ||
      !formData.staff_number
    );
  };

  const kitchenStaffRolesArray = Object.values(KITCHEN_STAFF_ROLES).map((role) => ({
    text: role,
    value: role
  }));

  return (
    <BaseModal position='right' title='Edit Member' isOpen onRequestClose={() => onClose()}>
      <Input
        name='staff_number'
        label='Staff Number'
        placeholder='SN-001'
        small
        disabled
        onChange={(e) => handleChange(e.target.value, 'staff_number')}
        value={editMemberFormData.staff_number}
      />
      <div className='grid grid-cols-2 gap-2 my-6'>
        <Input
          name='first_name'
          label='First Name'
          placeholder='Jeffery'
          small
          onChange={(e) => handleChange(e.target.value, 'first_name')}
          value={editMemberFormData.first_name}
        />
        <Input
          name='last_name'
          label='Last Name'
          placeholder='Williams'
          small
          onChange={(e) => handleChange(e.target.value, 'last_name')}
          value={editMemberFormData.last_name}
        />
      </div>
      <div className='mb-6'>
        <Input
          name='phone_number'
          label='Phone Number'
          placeholder='07030000000'
          small
          type='tel'
          onChange={(e) => handleChange(e.target.value, 'phone_number')}
          value={editMemberFormData.phone_number}
        />
      </div>
      <div className='mb-6'>
        <Input
          name='email'
          label='Email'
          placeholder='example@gmail.com'
          small
          type='email'
          onChange={(e) => handleChange(e.target.value, 'email')}
          value={editMemberFormData.email}
        />
      </div>
      <div className='mb-6'>
        <label className='font-medium'>Department</label>
        <Multiselect
          placeholder='Select Department'
          isSingle
          values={editMemberFormData.department_id ? [editMemberFormData.department_id] : []}
          options={departments}
          onChange={(e) => {
            handleChange(e[0], 'department_id');
          }}
        />
      </div>
      <div className='mb-6'>
        <label className='font-medium'>Role</label>
        <Multiselect
          placeholder='Select Role'
          isSingle
          values={editMemberFormData.role ? [editMemberFormData.role] : []}
          options={kitchenStaffRolesArray}
          onChange={(e) => {
            handleChange(e[0], 'role');
          }}
        />
      </div>
      <div className='mt-16'>
        <Button
          color='primary'
          variant='block'
          className='ms-auto max-w-[218px] h-[49px]'
          disabled={isFormDataInValid(editMemberFormData)}
          onClick={editMember}
          loading={loading}>
          Confirm
        </Button>
      </div>
    </BaseModal>
  );
};

export default EditMember;
